import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { FaClock, FaSearch, FaUsers, FaMobileAlt } from "react-icons/fa";



export default function PorqueSitioWeb() {
  const { t } = useTranslation();

  const items = [
    {
      icon: <FaClock />,
      title: t("porqueSitioWeb.beneficios.24_7"),
      desc: t("porqueSitioWeb.beneficios.24_7_desc"),
    },
    {
      icon: <FaUsers />,
      title: t("porqueSitioWeb.beneficios.confianza"),
      desc: t("porqueSitioWeb.beneficios.confianza_desc"),
    },
    {
      icon: <FaSearch />,
      title: t("porqueSitioWeb.beneficios.google"),
      desc: t("porqueSitioWeb.beneficios.google_desc"),
    },
    {
      icon: <FaMobileAlt />,
      title: t("porqueSitioWeb.beneficios.moviles"),
      desc: t("porqueSitioWeb.beneficios.moviles_desc"),
    },
  ];

  return (
    <Section id="beneficios">
      <Title>{t("porqueSitioWeb.titulo")}</Title>
      <ItemsGrid>
        {items.map((item, index) => (
          <Item
            key={index}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: index * 0.2 }}
          >
            <IconWrapper>{item.icon}</IconWrapper>
            <ItemTitle>{item.title}</ItemTitle>
            <Description>{item.desc}</Description>
          </Item>
        ))}
      </ItemsGrid>
    </Section>
  );
}
const Section = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 4rem 1rem;
  gap: 2rem;
`;

const Title = styled.h2`
  font-size: 2rem;
  color: #FF4C4C;
`;

const ItemsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
  gap: 2rem;
  max-width: 1000px;
  width: 100%;
`;

const Item = styled(motion.div)`
    background-color: #1a1a1a;
    padding: 2rem;
    border-radius: 1rem;
    box-shadow: 0 0 10px rgba(255, 76, 76, 0.2);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    border: 2px solid transparent;
    transition:  background .4s, border 1s;

  @media(min-width: 1024px) {
    cursor: pointer;
      &:hover {
        background-color:rgb(15, 15, 15);
        border: 2px solid #ff0f0f;
        }&:hover > p {
        height: 90%;
        }&:hover > h3{
        color: #fff;}}
        &:hover > a{
        background-color: #ff0f0f;
    }
`;

const IconWrapper = styled.div`
  font-size: 2rem;
  color: #FF4C4C;
`;

const ItemTitle = styled.h3`
  font-size: 1.2rem;
  font-weight: bold;
  color: #fff;
`;

const Description = styled.p`
  font-size: 0.95rem;
  color: #ccc;
`;